// extracted by mini-css-extract-plugin
module.exports = {"base":"ArtistPrintIndex_base__d4Xr3","title":"ArtistPrintIndex_title__3FEh3","body":"ArtistPrintIndex_body__cRkRH","inArticleView":"ArtistPrintIndex_inArticleView__tB1Jm"};